module.exports = __webpack_public_path__ + "img/all.3d211299.svg";